// https://material-ui.com/customization/color/#picking-colors
// https://in-your-saas.github.io/material-ui-theme-editor/
import {createMuiTheme, Theme} from '@material-ui/core';
import {DefaultTheme} from 'styled-components';

export type AppTheme =
    & DefaultTheme
    & Theme

const typography: Partial<AppTheme['typography']> = {
    fontFamily: `Poppins, sans-serif`,
    fontSize: 18,
    caption: {
        color: '#4F5D68'
    },
    h3: {
        fontFamily: `Poppins, sans-serif`,
        fontWeight: 400, // 'Poppins Regular'
        fontSize: '34px'
    }
};

export const appTheme = createMuiTheme({
    typography,
    overrides: {
        MuiDialog: {
            paper: {
                borderRadius: '12px'
            },
            scrollPaper: {
                alignItems: 'baseline'
            }
        },
        MuiOutlinedInput: {
            input: {
                padding: '14px 14px 14px'
            },
            notchedOutline: {
                borderColor: '#BBC2C2'
            },
            root: {
                borderRadius: '8px'
            }
        },
        MuiBackdrop: {
            root: {
                backgroundColor: 'rgb(203 203 203 / 50%)'
            }
        },
        MuiPickersToolbar: {
            toolbar: {
                backgroundColor: '#076cac'
            }
        },
        MuiPickersDay: {
            daySelected: {
                backgroundColor: '#076cac'
            },
            current: {
                color: '#0b8edb'
            }
        }
    } as any
} as AppTheme);
// cast as App theme as there is no generic type interface
